import { asField } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { ThemeNames } from '../../theming/ITheme.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { useState, useCallback } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _InputMessage from '../InputMessage/index.js';
import SelectRelativeContainer from './SelectRelativeContainer.js';
import _Label from '../Label/index.js';
import invariant from 'invariant';
import SelectContainer from './SelectContainer.js';

var _excluded = ["fieldApi", "fieldState"],
  _excluded2 = ["ariaLabelText", "disabled", "errorMessage", "field", "forwardedRef", "hideLabel", "hidePlaceholder", "initialValue", "invertedColor", "invertedColorError", "invertedColorSuccess", "floatingLabelBackgroundColor", "label", "language", "multiple", "onBlur", "onFocus", "onChange", "optional", "options", "placeholderText", "theme", "validate", "success"];
var _templateObject, _templateObject2, _templateObject3;
var StyledSelect = styled('select')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: none;\n  padding: 10px;\n  font-size: 1rem;\n  min-width: 100%;\n  max-width: 100%;\n  line-height: 14px;\n  height: 42px;\n  color: ", ";\n  background-color: ", ";\n  border: ", "\n    solid\n    ", ";\n  border-radius: ", ";\n\n  display: inline-block;\n  &:focus ~ #error-message {\n    display: none;\n  }\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  &:focus ~ #error-message {\n    display: none;\n  }\n  &:focus {\n    outline: none;\n    border: ", " solid\n      ", ";\n  }\n  option {\n    color: #000;\n  }\n  &::-ms-expand {\n    background: none;\n    border: none;\n  }\n"])), function (_ref) {
  var invertedColor = _ref.invertedColor,
    theme = _ref.theme;
  return theme.palette[invertedColor] || theme.palette.black;
}, function (_ref2) {
  var theme = _ref2.theme,
    error = _ref2.error,
    focus = _ref2.focus,
    invertedColor = _ref2.invertedColor;
  if (!focus && error) {
    return theme.palette[invertedColor] ? 'transparent' : theme.palette.errorLightest;
  } else {
    return theme.palette[invertedColor] ? 'transparent' : theme.palette.white;
  }
}, function (_ref3) {
  var error = _ref3.error,
    focus = _ref3.focus,
    invertedColor = _ref3.invertedColor;
  return !focus && error && invertedColor ? '4px' : '2px';
}, function (_ref4) {
  var theme = _ref4.theme,
    error = _ref4.error,
    success = _ref4.success,
    invertedColor = _ref4.invertedColor,
    invertedColorError = _ref4.invertedColorError,
    invertedColorSuccess = _ref4.invertedColorSuccess;
  if (success) {
    return theme.palette[invertedColorSuccess] || theme.palette.success;
  } else if (error) {
    return theme.palette[invertedColorError] || theme.palette.error;
  } else {
    return theme.name === ThemeNames.lincoln ? theme.palette[invertedColor] || theme.palette.grayLight : theme.palette.gray;
  }
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.border.size.medium;
}, function (_ref6) {
  var invertedColor = _ref6.invertedColor;
  return invertedColor ? '4px' : '2px ';
}, function (_ref7) {
  var invertedColor = _ref7.invertedColor,
    theme = _ref7.theme;
  return invertedColor ? theme.palette[invertedColor] : theme.palette[theme.input.focusBorderColor];
});
var SyledIconContainer = styled('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  border-bottom-right-radius: ", ";\n  border-top-right-radius: ", ";\n  font-size: 0.75rem;\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 2.66667rem;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.secondaryDark;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.border.size.medium;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.border.size.medium;
});
var StyledLfgLabel = styled(_Label)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1rem;\n  font-weight: 400;\n  font-style: ", ";\n  position: absolute;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transform-origin: top left;\n  left: 0;\n  top: 0;\n  margin-left: 0.625rem;\n  padding: 0 4px;\n  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  transform: translate(0px, 12px) scale(1);\n  background: linear-gradient(\n    transparent 48%,\n    ", "\n      40%\n  );\n  ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme,
    focus = _ref11.focus,
    invertedColor = _ref11.invertedColor,
    value = _ref11.value;
  return !focus && !value ? invertedColor && theme.palette[invertedColor] || theme.palette.gray : invertedColor && theme.palette[invertedColor] || theme.palette.grayDark;
}, function (_ref12) {
  var focus = _ref12.focus,
    value = _ref12.value;
  return !focus && !value ? 'italic' : 'none';
}, function (_ref13) {
  var error = _ref13.error,
    theme = _ref13.theme,
    focus = _ref13.focus,
    floatingLabelBackgroundColor = _ref13.floatingLabelBackgroundColor;
  return error && !focus ? floatingLabelBackgroundColor && theme.palette[floatingLabelBackgroundColor] || theme.palette.errorLightest : floatingLabelBackgroundColor && theme.palette[floatingLabelBackgroundColor] || theme.palette.white;
}, function (_ref14) {
  var focus = _ref14.focus,
    value = _ref14.value,
    error = _ref14.error;
  return (focus || value || error) && "\n      margin-left: 0.25rem;\n      padding: 0px 4px;\n      transform-origin: top left;\n      transform: translate(-2px,-10px) scale(.80);    \n    ";
});
var SelectInput = function SelectInput(_ref15) {
  var fieldApi = _ref15.fieldApi,
    fieldState = _ref15.fieldState,
    props = _objectWithoutProperties(_ref15, _excluded);
  var ariaLabelText = props.ariaLabelText,
    disabled = props.disabled,
    _props$errorMessage = props.errorMessage,
    errorMessage = _props$errorMessage === void 0 ? 'Please select an option' : _props$errorMessage,
    field = props.field,
    forwardedRef = props.forwardedRef,
    _props$hideLabel = props.hideLabel,
    hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
    _props$hidePlaceholde = props.hidePlaceholder,
    hidePlaceholder = _props$hidePlaceholde === void 0 ? false : _props$hidePlaceholde,
    initialValue = props.initialValue,
    invertedColor = props.invertedColor,
    invertedColorError = props.invertedColorError,
    invertedColorSuccess = props.invertedColorSuccess,
    floatingLabelBackgroundColor = props.floatingLabelBackgroundColor,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$language = props.language,
    multiple = props.multiple,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onChange = props.onChange,
    _props$optional = props.optional,
    options = props.options,
    _props$placeholderTex = props.placeholderText,
    placeholderText = _props$placeholderTex === void 0 ? 'Choose option' : _props$placeholderTex,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    validate = props.validate,
    success = props.success,
    rest = _objectWithoutProperties(props, _excluded2);
  var defaultValue = '';
  var value = fieldState.value,
    error = fieldState.error;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var displaySuccess = error === undefined && value && success ? true : false;
  var handleOnChange = function handleOnChange(e) {
    var options2 = e.target.options || [];
    var selected = _toConsumableArray(options2).filter(function (option) {
      return option.selected;
    }).map(function (option) {
      return option.value;
    });
    setValue(multiple ? selected : selected[0] || '');
    if (onChange) {
      onChange(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    setTouched(true);
    setFocus(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleFocus = useCallback(function (e) {
    setFocus(true);
    if (onFocus) {
      onFocus(e);
    }
  }, [setFocus, onFocus]);
  var stringifiedLabel = function stringifiedLabel() {
    if (typeof label === 'string' && label !== '') {
      return label;
    } else {
      return ariaLabelText;
    }
  };
  invariant(typeof label === 'string' || typeof label !== 'string' && !!ariaLabelText, 'You must provide ariaLabelText when using a jsx label');
  return /*#__PURE__*/React.createElement(SelectContainer, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(SelectRelativeContainer, null, /*#__PURE__*/React.createElement(StyledSelect, _extends({}, rest, {
    "aria-label": hideLabel ? stringifiedLabel() : undefined,
    disabled: disabled,
    error: error,
    id: field,
    ref: forwardedRef,
    invertedColor: invertedColor,
    invertedColorError: invertedColorError,
    invertedColorSuccess: invertedColorSuccess,
    multiple: multiple,
    onBlur: handleBlur,
    onChange: handleOnChange,
    onFocus: handleFocus,
    focus: focus,
    theme: theme,
    success: displaySuccess,
    value: value || (multiple ? [] : '')
  }), !multiple && !hidePlaceholder && /*#__PURE__*/React.createElement("option", {
    value: !focus && !error ? '' : defaultValue,
    disabled: true
  }, focus && !error && placeholderText), options.map(function (option, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: option.value
    }, option.label);
  })), !multiple && /*#__PURE__*/React.createElement(SyledIconContainer, {
    "data-testid": 'icon-container',
    theme: theme
  }, /*#__PURE__*/React.createElement(_Icon, {
    "aria-hidden": true,
    color: invertedColor || 'secondaryDarker',
    name: 'caret-down',
    size: 'medium',
    style: {
      backgroundColor: 'none'
    }
  })), !multiple && /*#__PURE__*/React.createElement(StyledLfgLabel, {
    "aria-owns": field,
    "data-testid": 'lfgStyle-input-label',
    error: !!error,
    floatingLabelBackgroundColor: floatingLabelBackgroundColor,
    focus: focus,
    htmlFor: field,
    invertedColor: invertedColor,
    theme: theme,
    value: value
  }, focus || value || error ? label : placeholderText)), error && !focus ? /*#__PURE__*/React.createElement(_InputMessage, {
    "aria-live": 'assertive',
    error: true,
    id: 'error-message',
    invertColors: !!invertedColor,
    role: 'alert',
    showIcon: false,
    style: {
      marginTop: ' 5px'
    },
    theme: themes.secureSite
  }, errorMessage) : null);
};
// @ts-ignore
var _SelectInput = withDefaultTheme(asField(SelectInput));

export default _SelectInput;
